/* Estrellas de Lunita Glow (11 oct 2026, Luis escogió «C · Estrellas que acompañan» y el pie «Noche de cierre").
   data-estrellas="crema"  -> estrellas oscuras de 4 puntas en 3 capas: al bajar, las grandes se mueven más que las chicas
                              (se siente profundidad) y se apartan un poco del mouse.
   data-estrellas="noche"  -> estrellas claras que titilan, constelaciones que se encienden y se borran, y a veces una estrella fugaz.
   Con movimiento reducido se dibujan quietas. Fuera de la pantalla no se dibuja nada (no gasta batería). */
(function () {
  if (window.__lunitaEstrellas) return; window.__lunitaEstrellas = 1;
  var anim = true;
  try { anim = !matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  var TINTA = "58,42,28", LUZ = "255,241,214", ORO = "233,196,138";

  function estrella(x, cx, cy, r) {                       // estrella de cuatro puntas
    x.beginPath(); x.moveTo(cx, cy - r);
    x.quadraticCurveTo(cx, cy, cx + r, cy); x.quadraticCurveTo(cx, cy, cx, cy + r);
    x.quadraticCurveTo(cx, cy, cx - r, cy); x.quadraticCurveTo(cx, cy, cx, cy - r); x.fill();
  }

  function montar(sec, n) {
    var noche = sec.getAttribute("data-estrellas") === "noche";
    var cv = document.createElement("canvas"); cv.className = "estrellas-lienzo"; cv.setAttribute("aria-hidden", "true");
    sec.insertBefore(cv, sec.firstChild);
    var x = cv.getContext("2d"), W = 0, H = 0, pts = [], lineas = [], fugaz = null, activo = !anim, s = 17 + n * 11;
    var raton = { x: -9999, y: -9999 };
    var azar = function () { return (s = (s * 9301 + 49297) % 233280) / 233280; };

    function tam() {
      var d = Math.min(2, window.devicePixelRatio || 1);
      W = sec.clientWidth; H = sec.clientHeight; if (!W || !H) return;
      cv.width = W * d; cv.height = H * d; x.setTransform(d, 0, 0, d, 0, 0); s = 17 + n * 11;
      var cuantas = Math.min(260, Math.round(W * H / (noche ? 6500 : 11000)));
      pts = Array.from({ length: cuantas }, function () {
        var c = azar();
        return { x: azar() * W, y: azar() * H, capa: 1 + Math.floor(azar() * 3), grande: c < .13,
                 r: c < .13 ? 3.6 + azar() * 3.2 : .8 + azar() * 1.5, f: azar() * 6.28, v: .3 + azar() * .9 };
      });
      if (!anim) dibujar(0);
    }

    function dibujar(t) {
      x.clearRect(0, 0, W, H);
      var color = noche ? LUZ : TINTA, base = noche ? .1 : .13, sube = noche ? .55 : .42;
      var desliz = sec.getBoundingClientRect().top;

      if (noche && pts.length) {                            // constelaciones
        if (anim && lineas.length < 3 && Math.random() < .008) {
          var a = pts[Math.floor(Math.random() * pts.length)];
          var cerca = pts.filter(function (p) { return p !== a && Math.abs(p.x - a.x) + Math.abs(p.y - a.y) < 170; }).slice(0, 3);
          if (cerca.length >= 2) lineas.push({ p: [a].concat(cerca), k: 0 });
        }
        lineas = lineas.filter(function (l) { return l.k < 1; });
        lineas.forEach(function (l) {
          l.k += .004; x.strokeStyle = "rgba(" + ORO + "," + (Math.sin(l.k * Math.PI) * .4).toFixed(3) + ")"; x.lineWidth = .8;
          x.beginPath(); x.moveTo(l.p[0].x, l.p[0].y); for (var i = 1; i < l.p.length; i++) x.lineTo(l.p[i].x, l.p[i].y); x.stroke();
        });
      }

      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var al = anim ? base + sube * Math.pow(Math.max(0, Math.sin(t / 1000 * p.v + p.f)), 2) : base + sube * .4;
        var px = p.x, py = p.y;
        if (!noche) {
          py = ((p.y + desliz * p.capa * .12) % H + H) % H;   // profundidad al bajar
          var dx = px - raton.x, dy = py - raton.y, dd = Math.sqrt(dx * dx + dy * dy);
          if (dd < 120 && dd > 0) { px += dx / dd * (120 - dd) * .35; py += dy / dd * (120 - dd) * .35; }
        }
        x.fillStyle = "rgba(" + color + "," + Math.min(1, al).toFixed(3) + ")";
        if (p.grande) estrella(x, px, py, p.r * 2.1);
        else if (!noche) estrella(x, px, py, p.r * (1.1 + p.capa * .45));
        else { x.beginPath(); x.arc(px, py, p.r * .75, 0, 6.28); x.fill(); }
      }

      if (noche && anim) {                                  // estrella fugaz de vez en cuando
        if (!fugaz && Math.random() < .002) fugaz = { x: Math.random() * W * .6, y: Math.random() * H * .35, k: 0 };
        if (fugaz) {
          fugaz.k += .016; var L = 140, qx = fugaz.x + fugaz.k * 420, qy = fugaz.y + fugaz.k * 150;
          var g = x.createLinearGradient(qx - L, qy - L * .36, qx, qy);
          g.addColorStop(0, "rgba(" + LUZ + ",0)"); g.addColorStop(1, "rgba(" + LUZ + "," + (.85 * (1 - fugaz.k)).toFixed(3) + ")");
          x.strokeStyle = g; x.lineWidth = 1.3; x.beginPath(); x.moveTo(qx - L, qy - L * .36); x.lineTo(qx, qy); x.stroke();
          if (fugaz.k >= 1) fugaz = null;
        }
      }
    }

    if (!noche) {
      sec.addEventListener("pointermove", function (e) { if (e.pointerType !== "mouse") return; var r = sec.getBoundingClientRect(); raton.x = e.clientX - r.left; raton.y = e.clientY - r.top; });
      sec.addEventListener("pointerleave", function () { raton.x = raton.y = -9999; });
    }
    tam(); window.addEventListener("resize", tam);
    if ("ResizeObserver" in window) new ResizeObserver(tam).observe(sec);
    if (anim) {
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { es.forEach(function (e) { activo = e.isIntersecting; }); }).observe(sec);
      else activo = true;
      (function bucle(t) { if (activo && !document.hidden) dibujar(t || 0); requestAnimationFrame(bucle); })(0);
    }
  }

  function iniciar() { document.querySelectorAll("[data-estrellas]").forEach(montar); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar); else iniciar();
})();
